import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-opportunity';
import type { ViewOption } from '@ctw/shared/content/resource/view-button';

// Filter for type
function typeFilter(types: Array<RiskGapModel['type']>) {
  return (data: Array<RiskGapModel>) => data.filter((c) => types.includes(c.type));
}

export type RiskGapViewOptions = 'Recapture' | 'Suspect' | 'All';

const viewOptions: Array<ViewOption<RiskGapModel>> = [
  {
    display: 'Recapture',
    filters: [typeFilter(['recapture'])],
  },
  {
    display: 'Suspect',
    filters: [typeFilter(['suspect'])],
  },
  {
    display: 'All',
    filters: [(data: Array<RiskGapModel>) => data],
  },
];

export const RiskGapView = {
  viewOptions,
  recapture: viewOptions[0],
  suspect: viewOptions[1],
  all: viewOptions[2],
};
